<!-- 编辑预览赛事 -->
<template>
    <div class="page-form">
        <PageBack :title="title" />
        <div class="detail-wrap" v-if="firstStep">            
            <el-row>添加信息  <span class="red text-tips">*注册该系统会有积分</span></el-row>
            <el-row class="mg-tb-20">赛事预览链接为：<a :href="url" target="_blank"> {{url}} </a></el-row>
            
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">  
                <el-row >  
                    <el-col :span="12">
                       
                    </el-col>   
                    <el-col :span="12">
                        <el-form-item label="荣誉分"  class="form" >
                            <el-input type="number" v-model="totalGrade" readonly>
                                <template slot="append">分</template>
                            </el-input>
                        </el-form-item>
                    </el-col>                     
                </el-row>     
            </el-form>   
            <host :publishId="publishId" @maxLevel="getMaxLevel"></host>
            <under-take :publishId="publishId" @maxLevel="getMaxLevel"></under-take>
            <sponsor :publishId="publishId"></sponsor>
            <organizer :publishId="publishId" @maxLevel="getMaxLevel"></organizer>            
            <referee :publishId="publishId" @maxLevel="getRefereeLevel"></referee>
        </div >
        <div class="detail-wrap" v-else>   
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" 
            label-width="100px" class="demo-ruleForm">                   
            <el-row>
                <el-form-item label="活动标题" prop="title">
                    <el-input type="text" v-model="ruleForm.title" placeholder="请输入内容"/>
                </el-form-item>                 
            </el-row>
            <div class="red address-notice">注意：一旦正式发布，标题无法再次修改，只能用另外复制一场比赛的方式修改。</div>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="冠名单位" prop="sponsor">  
                        <el-autocomplete style="width: 100%;" :clearable="true"
                            v-model="ruleForm.sponsor"
                            :fetch-suggestions="querySearchSponsor"
                            placeholder="请输入内容"
                            :trigger-on-focus="false"
                            @select="handleSelectSponsor"
                            @change="handleChangeSponsor"
                        ></el-autocomplete>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="指导单位" prop="guidanceName">  
                        <el-autocomplete style="width: 100%;" :clearable="true"
                            v-model="ruleForm.guidanceName"
                            :fetch-suggestions="querySearchGuidance"
                            placeholder="请输入内容"
                            :trigger-on-focus="false"
                            @select="handleSelectGuidance"
                            @change="handleChangeGuidance"
                        ></el-autocomplete>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="red address-notice">注意：比赛结束后，请加微信18051859136，提取报名费，每周提取一次。</div> 
            <el-row > 
                <el-col :span="6">
                    <el-form-item label="报名费用" prop="eventFee">
                        <el-input type="text" v-model="ruleForm.eventFee" 
                            @input="handleFee"  maxlength="10"
                            placeholder="请输入报名费用">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="是否隐藏" prop="hideField">
                       <el-radio-group v-model="ruleForm.hideField">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="赛事类型" prop="type">
                        <el-radio-group v-model="ruleForm.type">
                            <el-radio :label="item.value"
                                v-for="item in eventTypeList" 
                                :key="item.label">{{ item.label }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col> 
            </el-row>            
            <div class="red address-notice">
                注意：隐藏比赛，即为非公开比赛，发布人请到小程序，我的-我的发布中，查看后转发。
            </div>          
            <el-row :gutter="24"> 
                 <el-col :span="12">               
                    <el-form-item label="赛事省市" required>
                        <el-cascader
                            v-model="ruleForm.region"
                            :options="regionOptions"
                            placeholder="请选择省市"
                            @change="selectArea"
                            style="width: 100%;">
                        </el-cascader>           
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="赛事地点" prop="eventPlace">
                        <el-input type="text" v-model="ruleForm.eventPlace" placeholder="请输入赛事详细地址"/>
                    </el-form-item>
                </el-col>                
            </el-row>
            <div class="red address-notice"> 
                注意：请在正式发布后，在微信小程序上测试导航是否准确，否则，会出现无法签到、无法记录成绩等情况。
            </div>  
            <el-row :gutter="24"> 
                <el-col :span="8">
                    <el-form-item label="赛事轮数" prop="eventRound">
                        <el-input type="text" v-model="ruleForm.eventRound" placeholder="请输入内容">
                        <template slot="append">轮</template></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="参赛人数" prop="amount">
                        <el-input type="number" v-model="ruleForm.amount" placeholder="请输入内容">
                            <template slot="append">人</template>
                        </el-input>
                        <span class="red">比赛不满24人时，积分为0</span>
                    </el-form-item>
                </el-col> 
                <el-col :span="8">
                    <el-form-item label="联系方式" prop="eventContact">
                        <el-input type="text" v-model="ruleForm.eventContact" 
                            @input="handlePhone" maxlength="11"
                            placeholder="请输入内容">                           
                        </el-input>
                    </el-form-item>
                </el-col>              
            </el-row>
            <!-- <el-row  :gutter="20"> 
                <el-col :span="10">
                    <el-form-item label="报名日期" prop="applyDate">
                        <el-date-picker
                        v-model="ruleForm.applyDate"
                        @change="selectApplyDate"
                        type="daterange"                        
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="报名时间" prop="applyTime">
                        <el-time-picker
                            is-range
                            v-model="ruleForm.applyTime"
                            @change="selectApplyTime"
                            value-format="HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>       
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row :gutter="20"> 
                <el-col :span="12">
                    <el-form-item label="赛事日期" prop="eventDate">
                        <el-date-picker  v-model="ruleForm.eventDate"
                            type="date"                            
                            value-format="yyyy-MM-dd" style="width: 100%;">
                        </el-date-picker>              
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="赛事时间" prop="eventTime">
                        <el-time-picker
                            is-range
                            v-model="ruleForm.eventTime" 
                            @change="selectEventTime"                         
                            value-format="HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>      
                    </el-form-item>
                </el-col>
            </el-row>
            <!--<el-row>
                 <el-col :span="14">
                    <el-form-item label="维度级别" prop="hostDimension" class="form" >
                        <el-select v-model="ruleForm.hostDimension" style="width:250px"
                            @change="selectHostDimension($event,1)">
                            <el-option 
                                v-for="item in hostGradeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select><span>(主办或承办)</span><br>
                        <el-select v-model="ruleForm.entryDimension" style="width:250px" 
                            @change="selectHostDimension($event,2)">
                            <el-option 
                                v-for="item in entryGradeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select><span>(参赛维度)</span><br>
                        <el-select v-model="ruleForm.faceDimension" style="width:250px"
                            @change="selectHostDimension($event,3)">
                            <el-option 
                                v-for="item in faceGradeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select><span>(面向维度)</span><br>
                        <el-select v-model="ruleForm.prizeDimension" style="width:250px"
                            @change="selectHostDimension($event,4)">
                            <el-option 
                                v-for="item in prizeGradeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select><span>(奖品维度)</span><br>
                        <el-select v-model="ruleForm.refereeDimension" style="width:250px"
                            @change="selectHostDimension($event,5)">
                            <el-option 
                                v-for="item in refereeGradeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select><span>(裁判维度)</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row>
                <el-col :span="12">
                    <!-- <el-form-item label="奖品价值" prop="championValue" class="form" >
                        <el-input type="number" v-model="ruleForm.championValue" placeholder="请输入内容">
                            <template slot="append">元</template></el-input>
                    </el-form-item> -->
                    <el-form-item label="参赛范围" prop="hostDimension" class="form" >
                        <el-select v-model="ruleForm.faceDimension" style="width:100%"
                            @change="selectHostDimension($event,3)">
                            <el-option 
                                v-for="item in faceGradeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="荣誉分"  class="form" >
                        <el-input type="number" v-model="totalGrade" readonly>
                            <template slot="append">分</template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row >   
            <el-row> 
                <el-col :span="12">
                    <el-form-item label="分享图片" prop="shareImage">
                    <el-upload  
                            ref="coverPicUpload5" action="" 
                            list-type="picture" 
                            accept="image/*"
                            multiple :limit="1" name="file" 
                            :file-list="fileList5"
                            :on-remove="handleRemove5"
                            :http-request="handleRequest5"
                            :before-upload="handleBeforeUpload" 
                            :on-error="handleUploadError">
                            <el-button size="small" type="primary">上传图片</el-button>
                            <span class="red">图片尺寸为： 1080×864</span>
                        </el-upload>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="封面图片" prop="coverImage">
                    <el-upload  
                            ref="coverPicUpload6" action="" 
                            list-type="picture" 
                            accept="image/*"
                            multiple :limit="1" name="file" 
                            :file-list="fileList6"
                            :on-remove="handleRemove6"
                            :http-request="handleRequest6"
                            :before-upload="handleBeforeUpload" 
                            :on-error="handleUploadError">
                            <el-button size="small" type="primary">上传图片</el-button>
                            <span class="red">图片尺寸为： 750×375</span>
                        </el-upload>
                </el-form-item>
                </el-col>  
            </el-row>              
            <el-row>
                <el-form-item label="奖励设置" prop="award">
                    <el-input type="textarea" v-model="ruleForm.award" 
                    :rows="4" placeholder="请输入内容"/>
                    <el-upload  
                            ref="coverPicUpload2" action="" 
                            list-type="picture" 
                            accept="image/*"
                            multiple :limit="1" name="file" 
                            :file-list="fileList2"
                            :on-remove="handleRemove2"
                            :http-request="handleRequest2"
                            :before-upload="handleBeforeUpload" 
                            :on-error="handleUploadError">
                            <el-button size="small" type="primary">上传图片</el-button>
                        </el-upload>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="赛事流程" prop="eventFlow">
                    <el-input type="textarea" v-model="ruleForm.eventFlow" 
                    :rows="5" placeholder="请输入内容"/>
                    <el-upload 
                        ref="coverPicUpload1" action="" 
                        list-type="picture" accept="image/*"
                        multiple :limit="1" name="file"
                        :file-list="fileList1" 
                        :on-remove="handleRemove1"
                        :http-request="handleRequest1"
                        :before-upload="handleBeforeUpload" 
                        :on-error="handleUploadError">
                        <el-button size="small" type="primary">上传图片</el-button>
                    </el-upload>
                </el-form-item>    
            </el-row>
            <el-row>
                <el-form-item label="报名须知" prop="notice">
                    <el-input type="textarea" v-model="ruleForm.notice" 
                    :rows="8" placeholder="请输入内容"/>
                    <el-upload class="avatar-uploader" 
                        ref="coverPicUpload3" action="" 
                        list-type="picture" accept="image/*"
                        multiple :limit="1" name="file" 
                        :file-list="fileList3"
                        :on-remove="handleRemove3"
                        :http-request="handleRequest3"
                        :before-upload="handleBeforeUpload" 
                        :on-error="handleUploadError">
                        <el-button size="small" type="primary">上传图片</el-button>
                    </el-upload>
                </el-form-item>          
            </el-row>                  
            <el-row>
                <el-form-item label="竞赛规则" prop="rules">
                    <el-input type="textarea" v-model="ruleForm.rules"
                :rows="8" placeholder="请输入内容"/>
                <el-upload class="avatar-uploader" 
                        ref="coverPicUpload4" action="" 
                        list-type="picture" accept="image/*"
                        multiple :limit="1" name="file" 
                        :file-list="fileList4"
                        :on-remove="handleRemove4"
                        :http-request="handleRequest4"
                        :before-upload="handleBeforeUpload" 
                        :on-error="handleUploadError">
                        <el-button size="small" type="primary">上传图片</el-button>
                    </el-upload>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="参赛承诺书" prop="letter">
                        <el-input type="textarea" v-model="ruleForm.letter"
                    :rows="5" placeholder="请输入内容"/>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item>
                    <el-button round block type="primary" @click="submitForm('ruleForm')" 
                    class="pub-submit" :disabled="disabledBtn">
                        {{ publishButton }}
                    </el-button>
                    <a :href="url" target="_blank">{{url}}</a>
                </el-form-item>
            </el-row>
        </el-form> 
        </div>       
    </div>
</template>
<script>
import PageBack from '@/components/PageHeader'
import list from '@/config/pubObj'
import Breadcrumb from '@/components/Breadcrumb'
import Host from './components/host'
import UnderTake from './components/underTake'
import Sponsor from './components/sponsor'
import Organizer from './components/Organizer'
import Referee from './components/refereeQuery'
import { regionFormData } from '@/assets/js/region.js'
export default {
    components: {
        Breadcrumb,
        Host,
        UnderTake,
        Sponsor,
        Organizer,
        Referee,
        PageBack
    },
    data() {
        return { 
            regionOptions: regionFormData,
            loading: false,           
            firstStep: false,
            senconds: 5,
            disabled: false,
            disabledBtn: false,
            timer: null,
            ruleForm: list,
            ready:false,
            rules:{
                title:[
                    { required: true, message: '请输入活动标题', trigger: 'blur' },
                ],
                type: [
                    { required: true, message: '请选择赛事类型', trigger: 'change' },
                ],
                eventPlace: [
                    { required: true, message: '请输入赛事详细地址', trigger: 'blur' },
                ],
                province: [
                    { required: true, message: '请选择省份', trigger: 'change' },
                ],
                city: [
                    { required: true, message: '请选择城市', trigger: 'change' },
                ],
                amount: [
                    { required: true, message: '请输入参数人数', trigger: 'blur' },
                ],
                eventFee: [
                    { required: false, message: '请输入报名费用', trigger: 'blur' },
                ],
                applyDate: [
                    { required: false, message: '请选择报名日期', trigger: 'change' },
                ],
                applyTime: [
                    { required: false, message: '请选择报名时间', trigger: 'change' },
                ],
                eventDate: [
                    { required: true, message: '选择赛事日期', trigger: 'change' },
                ],
                eventTime: [
                    { required: true, message: '选择赛事时间', trigger: 'change' },
                ],
                imageUrl: [
                    { required: false, message: '请上传图片', trigger: 'change' },
                ],
                dimension:[
                    { required: true, message: '请选择维度', trigger: 'change' },
                ],
                championValue: [
                    { required: true, message: '请输入奖品价值',trigger: 'change'}
                ],
                region: [
                    { required: true, message: '请选择省市', trigger: 'change' },
                ]
            },
            url: '',
            eventTypeList:this.$global.eventTypeList,
            publishId: '',
            newApplyDate: [], 
            serialMark: '',
            imageRule: '',
            // 新增上传图片字段
            rewardImage: '',
            flowImage: '', //赛事流程图
            noticeImage: '',
            eventRuleImage: '',
            fileList1: [], //赛事流程图
            fileList2: [], //
            fileList3: [], //报名须知图
            fileList4: [],
            fileList5: [],
            fileList6: [],
            hostGradeList: [],
            entryGradeList: [],
            faceGradeList: [],
            prizeGradeList: [],
            refereeGradeList: [],
            hostGrade: 20, 
            entryGarde: 20,
            faceGrade: 20,
            prizeGrade: 20, 
            refereeGrade: 20,
            typeCopy: '',
            // 5个纬度默认数组
            // 主办，奖品，裁判，参赛，面向 5个纬度每个级别20分
            gradeArr: [
                { value: 0,grade: 0,},
                { value: 1,grade: 20,},
                { value: 2,grade: 40,},
                { value: 3,grade: 60,},
                { value: 4,grade: 80,},
                { value: 5,grade: 100,},
            ],
            publishButton:'修改预览赛事'
        }
    },   
    computed: {
        title() {
            if(this.typeCopy === 'copy'){
                this.publishButton = '发布预览赛事'
                return '发布预览赛事'
            }else{
                return this.$route.meta.title
            }            
        },
        totalGrade(){
            if(this.ruleForm.amount < 32){
                return 0
            }else{
                let  {hostGrade, entryGarde, faceGrade, prizeGrade, refereeGrade } = this
                let sumGrade  = parseInt(hostGrade)  + parseInt(entryGarde) + 
                    parseInt(faceGrade) + parseInt(prizeGrade) + parseInt(refereeGrade)
                console.log(hostGrade, entryGarde, faceGrade, prizeGrade, refereeGrade,sumGrade)
                return sumGrade   
            }      
        }
    },
    watch:{
        'ruleForm.amount'(v){
            if(v <  32){
                this.entryGarde = 20
                this.ruleForm.entryDimension = 1
            }else if( v >= 100 && v < 199){
                this.entryGarde = 40
                this.ruleForm.entryDimension = 2
            }else if( v >= 200 && v < 499){
                this.entryGarde = 60
                this.ruleForm.entryDimension = 3
            }else if( v >= 500 && v < 999){
                this.entryGarde = 80
                this.ruleForm.entryDimension = 4
            }else if( v >= 1000){
                this.entryGarde = 100
                this.ruleForm.entryDimension = 5
            }
        },
        'ruleForm.eventRound'(v){
            if(v < 3){
                this.prizeGrade = 20
                this.ruleForm.prizeDimension = 1
            }else if(v > 2 &&  v < 5){
                this.prizeGrade = 40
                this.ruleForm.prizeDimension = 2
            }else if( v > 4 && v < 7){
                this.prizeGrade = 60
                this.ruleForm.prizeDimension = 3
            }else if( v > 6 && v < 11){
                this.prizeGrade = 80
                this.ruleForm.prizeDimension = 4
            }else if( v > 10){
                this.prizeGrade = 100
                this.ruleForm.prizeDimension = 5
            }
        },
        // 'ruleForm.championValue'(v){
        //     if(v <  1000){
        //         this.prizeGrade = 20
        //         this.ruleForm.prizeDimension = 1
        //     }else if( v >= 1000 && v < 4999){
        //         this.prizeGrade = 40
        //         this.ruleForm.prizeDimension = 2
        //     }else if( v >= 5000 && v < 19999){
        //         this.prizeGrade = 60
        //         this.ruleForm.prizeDimension = 3
        //     }else if( v >= 20000 && v < 49999){
        //         this.prizeGrade = 80
        //         this.ruleForm.prizeDimension = 4
        //     }else if( v >= 5000){
        //         this.prizeGrade = 100
        //         this.ruleForm.prizeDimension = 5
        //     }
        // },

    },
    created() {  
        this.ready = true;     
        this.publishId = this.$route.query.id
        this.typeCopy = this.$route.query.type || ''  
        if(this.publishId && this.typeCopy === 'copy'){
            // console.log("object")
            this.disabled = false
        }else{
            this.disabled = true
        }     
        this.getHostGrade()
        this.getEntryGrade()
        this.getFaceGrade()
        this.getPrizeGrade()
        this.getRefereeGrade()   
    },    
    mounted() {
        if(this.publishId){
            this.initData()
        }
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.PubPreview,
                i_serial_mark: this.publishId,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list  = result.map(item=>{

                    let s1 =  item['赛事开始日期'].slice(0,10)
                    let s11 =  item['赛事开始日期'].slice(11)
                    let s22 = item['赛事结束日期'].slice(11)
                    let type = this.eventTypeList.filter(i=>i.label === item['类型'])
                    let status = item['状态'] ==='赛事完成'? 0 : item['状态'] ==='赛事报名中'? 1:3
                    console.log(item['主办或承办维度级别'])
                    let hostArr = this.gradeArr.filter(i=>i.value === item['主办或承办维度级别'])
                    this.hostGrade  = hostArr && hostArr[0].grade
                    console.log('取到的分数',hostArr[0].grade)
                    let entryArr = this.gradeArr.filter(i=>i.value === item['参赛维度级别'])
                    this.entryGarde = entryArr && entryArr[0].grade

                    let faceArr = this.gradeArr.filter(i=>i.value === item['面向维度级别'])
                    this.faceGrade = faceArr && faceArr[0].grade

                    let prizeArr =  this.gradeArr.filter(i=>i.value === item['奖品维度级别'])
                    this.prizeGrade = prizeArr && prizeArr[0].grade

                    let refereeArr = this.gradeArr.filter(i=>i.value === item['裁判维度级别'])
                    this.refereeGrade = refereeArr && refereeArr[0].grade

                        return{
                            serial: item['标识'],
                            title: item['主题'],
                            type: type[0].value,
                            amount: item['参赛人数'],
                            eventFee: item['报名费用'],
                            hideField: item['是否隐藏'] === 'true' ? true: false,
                            eventPlace: item['赛事地点'],
                            sponsor: item['赞助'],
                            sponsorNo: item['赞助账号'],
                            award: item['奖励设置'],
                            eventFlow: item['赛事流程'],
                            notice: item['报名须知'],
                            rules:item['竞赛规则'],
                            letter: item['参赛承诺'],
                            eventContact: item['备注'],
                            eventRound: item['轮数'],                            
                            eventDate: s1,
                            eventTime: [s11,s22],   
                            eventStartTime: s11,
                            eventEndTime: s22,                          
                            status: status,
                            eventQrcode: '',
                            groupQrcode:'',
                            applyUrl: item['报名链接'],
                            imageUrl: '',
                            // 4张图片
                            flowImageUrl: item['赛事流程图片1'],                           
                            rewardImageUrl:  item['奖励设置图片1'],
                            noticeImageUrl: item['报名须知图片1'],
                            ruleImageUrl:  item['竞赛规则图片1'],
                            // 5个纬度
                            hostDimension: item['主办或承办维度级别'],
                            entryDimension: item['参赛维度级别'],
                            faceDimension: item['面向维度级别'],
                            prizeDimension: item['奖品维度级别'],
                            refereeDimension: item['裁判维度级别'],
                            grade: item['系统积分'],
                            guidanceName:item['指导单位'],
                            guidanceNo: item['指导单位账号'],
                            championValue: item['价值'],
                            province: item['赛事地点省份'],
                            city: item['赛事地点市'],
                            shareImage: item['赛事流程图片2'],
                            coverImage: item['图片1'],
                            region: [item['赛事地点省份'],item['赛事地点市']]
                        }
                    })  
                    // console.log('编辑的数据',list[0])
                    this.ruleForm = list[0]
                    if(list[0].flowImageUrl){
                        this.fileList1 = [{name:'',url: this.ruleForm.flowImageUrl }]
                    }
                    if(list[0].rewardImageUrl){
                        this.fileList2 = [{name:'',url: this.ruleForm.rewardImageUrl }]
                    }
                    if(list[0].noticeImageUrl){
                        this.fileList3 = [{name:'',url: this.ruleForm.noticeImageUrl }]
                    }
                    if(list[0].ruleImageUrl){
                        this.fileList4 = [{name:'',url: this.ruleForm.ruleImageUrl }]
                    }    
                    if(list[0].shareImage){
                        this.fileList5 = [{name:'',url: this.ruleForm.shareImage }]
                    }   
                    if(list[0].coverImage){
                        this.fileList6 = [{name:'',url: this.ruleForm.coverImage }]
                    }               
                }
            })
        },
        // 获取赛事类型
        getEventType(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 13,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.eventTypeList = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                }
            })
        },
        // 获取赛事评定维度 主办或承办维度
        getHostGrade(){
            let params = {
                opcode: this.$code.PubGradeCode,
                i_no: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.hostGradeList = result.map(item=>{
                        return{
                            grade: item['对应积分'],
                            des: item['说明'],
                            value: item['级别'],
                            label: item['评定类型']
                        }
                    })
                }
            })
        },
        // 获取赛事评定维度 参赛维度
        getEntryGrade(){
            let params = {
                opcode: this.$code.PubGradeCode,
                i_no: 2,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.entryGradeList = result.map(item=>{
                        return{
                            grade: item['对应积分'],
                            des: item['说明'],
                            value: item['级别'],
                            label: item['评定类型']
                        }
                    })
                }
            })
        },
        // 获取赛事评定维度  面向维度
        getFaceGrade(){
            let params = {
                opcode: this.$code.PubGradeCode,
                i_no: 3,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.faceGradeList = result.map(item=>{
                        return{
                            grade: item['对应积分'],
                            des: item['说明'],
                            value: item['级别'],
                            label: item['评定类型']
                        }
                    })
                }
            })
        },
        // 获取赛事评定维度  奖品维度
        getPrizeGrade(){ 
            let params = {
                opcode: this.$code.PubGradeCode,
                i_no: 4,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.prizeGradeList = result.map(item=>{
                        return{
                            grade: item['对应积分'],
                            des: item['说明'],
                            value: item['级别'],
                            label: item['评定类型']
                        }
                    })
                }
            })
        },
        // 获取赛事评定维度 裁判
        getRefereeGrade(){
            let params = {
                opcode: this.$code.PubGradeCode,
                i_no: 5,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.refereeGradeList = result.map(item=>{
                        return{
                            grade: item['对应积分'],
                            des: item['说明'],
                            value: item['级别'],
                            label: item['评定类型']
                        }
                    })
                }
            })
        },
        submitForm(formName){             
            this.$refs[formName].validate((valid) => {    
                if(valid){
                    this.handleSubmit()
                }else{
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    return false;
                }
            })
        },
        handleSubmit(){
            let {type, title,sponsor,sponsorNo,award,amount, eventFee, eventPlace,notice,eventContact,eventRound,
                eventFlow,rules,letter,eventDate,eventStartTime,eventEndTime,championValue,
                eventQrcode,groupQrcode,applyUrl,status,guidanceName, guidanceNo,                
                rewardImageUrl,flowImageUrl,noticeImageUrl,ruleImageUrl,
                hostDimension,entryDimension,faceDimension,prizeDimension,refereeDimension,
                province,city,shareImage,coverImage,hideField} = this.ruleForm  
  
            let eventStartDate =  eventDate +' '+ eventStartTime
            let eventEndDate = eventDate +' '+ eventEndTime     
            let opcode =   this.publishId && this.typeCopy==='' ? 
                this.$code.PublishUpdateCode : this.$code.PublishCode  
            let params = {}
            let addParams = {
                opcode: opcode,
                v_type: type,
                v_theme: title,
                i_free: eventFee,
                v_sponsor: sponsor,
                i_sponsor_no: sponsorNo,
                v_reward_settings: award,
                v_numberofpeople: amount,
                v_signup_start_date: 0,
                v_signup_start_time: 0,
                v_signup_end_date: 0,
                v_signup_end_time: 0,
                v_event_start_date: eventStartDate,
                v_event_end_date: eventEndDate,
                v_event_place: eventPlace,
                v_event_province: province,
                v_event_city: city,
                v_event_flow: eventFlow,
                v_event_notice: notice,
                v_event_rule: rules,                
                v_event_acceptance: letter,
                i_remarks: eventContact,
                i_round: eventRound,
                v_event_image: eventQrcode,
                v_event_group_image: groupQrcode,
                v_user_event: applyUrl,
                v_event_rule_image: '', //赛事图片
                // 新增上传图片字段                
                v_reward_settings_imagess1: rewardImageUrl,
                v_event_flow_imagess1: flowImageUrl,
                v_event_notice_imagess1: noticeImageUrl,                
                v_event_rule_imagess1: ruleImageUrl,
                v_guidance_name: guidanceName,
                v_guidance_no: guidanceNo,
                i_integral: this.totalGrade,
                i_value: 0,
                // 维度级别               
                d_host_dimension: hostDimension,
                d_entry_dimension: entryDimension,
                d_face_dimension: faceDimension,
                d_prize_dimension: prizeDimension,
                d_referee_dimension: refereeDimension,
                v_event_flow_imagess2: shareImage,//小程序分享的图片
                i_images1: coverImage,//小程序封面图,
                v_hide: hideField,
            }
           
            let updateParams = {
                i_serial_mark: this.publishId,
                c_status: status,
            }
            if(this.publishId && this.typeCopy ===''){
                // console.log("更新")
                params =  Object.assign({}, addParams, updateParams)
            }else{
                // console.log("新增")
                params = addParams
            }
            console.log(params)
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {                    
                    this.disabledBtn = true 
                    this.firstStep = true   
                    let  serial = ''
                    if(this.publishId && this.typeCopy ===''){
                        serial = this.publishId
                    }else{
                        serial = this.splitStr(res.Message) 
                    }      
                    setTimeout(()=>{
                        this.submitGrade()
                    },500)                      
                    this.url = window.location.origin + '/#/publishPreview?id=' + serial
                    this.$message.success(res.Message)  
                    this.publishId = serial             
                }else{
                    this.$message.error(res.Message)
                }
            })    
        },
        // 截图中括号里面的赛事标识符
        splitStr(str){
            let result = ''
            if(str){
                const regex = /\[([^\]]+)\]/g;
                let match = regex.exec(str)
                result = match[1]
            }           
            return result
        },
        selectApplyDate(value){
            this.ruleForm.applyStartDate  = value[0].replace(/-/g, '')
            this.ruleForm.applyEndDate  = value[1].replace(/-/g, '')
        },
        selectApplyTime(value){
            this.ruleForm.applyStartTime  = value[0].replace(/:/g, '')
            this.ruleForm.applyEndTime  = value[1].replace(/:/g, '')
        },   
        selectEventTime(value){
            if(value){
                this.ruleForm.eventStartTime  = value[0]
                this.ruleForm.eventEndTime  = value[1]
            }            
        },
        async handleRequest(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.imageRule  = url
            this.ruleForm.imageUrl = this.$global.uploadUrl + url
            this.loading.close();
            this.$refs.coverPicUpload.clearFiles()
        },  
        async handleRequest1(file,fileList){
            let url = await this.$help.uploadRequest(file)
            // this.flowImage  = url
            this.ruleForm.flowImageUrl = this.$global.uploadUrl + url
            this.fileList1 = [
                {name:file.file.name,url: this.ruleForm.flowImageUrl }
            ]
            this.loading.close();
            this.$refs.coverPicUpload1.clearFiles()
        },  
        async handleRequest2(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.rewardImageUrl = this.$global.uploadUrl + url
            this.fileList2 = [
                {name:file.file.name,url: this.ruleForm.rewardImageUrl }
            ]
            this.loading.close();
            this.$refs.coverPicUpload2.clearFiles()
        },  
        async handleRequest3(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.noticeImageUrl = this.$global.uploadUrl + url
            this.fileList3 = [
                {name:file.file.name,url: this.ruleForm.noticeImageUrl }
            ]
            this.loading.close();
            this.$refs.coverPicUpload3.clearFiles()
        },  
        async handleRequest4(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.ruleImageUrl = this.$global.uploadUrl + url
            this.fileList4 = [
                {name:file.file.name,url: this.ruleForm.ruleImageUrl }
            ]
            this.loading.close();
            this.$refs.coverPicUpload4.clearFiles()
        },  
        async handleRequest5(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.shareImage = this.$global.uploadUrl + url
            this.fileList5 = [
                {name:file.file.name,url: this.ruleForm.shareImage }
            ]
            this.loading.close();
            this.$refs.coverPicUpload5.clearFiles()
        }, 
        async handleRequest6(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.coverImage = this.$global.uploadUrl + url
            this.fileList6 = [
                {name:file.file.name,url: this.ruleForm.coverImage }
            ]
            this.loading.close();
            this.$refs.coverPicUpload6.clearFiles()
        },  
        handleRemove(file, fileList) {
            this.ruleForm.imageUrl = ''
        },
        handleRemove1(file, fileList) {
            this.ruleForm.flowImageUrl = ''
            this.fileList1 = []
        },
        handleRemove2(file, fileList) {
            this.ruleForm.rewardImageUrl = ''
            this.fileList2 = []
        },
        handleRemove3(file, fileList) {
            this.noticeImage = ''
            this.ruleForm.noticeImageUrl = ''
            this.fileList3 = []
        },     
        handleRemove4(file, fileList) {
            this.ruleForm.ruleImageUrl = ''
            this.fileList4 = []
        }, 
        handleRemove5(file, fileList) {
            this.ruleForm.shareImage = ''
            this.fileList5 = []
        },
        handleRemove6(file, fileList) {
            this.ruleForm.coverImage = ''
            this.fileList6 = []
        },
        handleBeforeUpload() {
            this.loading = true
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        },
        handleUploadError() {
            // this.loading = false
            // this.$message({
            //     type: "error",
            //     message: "上传失败",
            // });
            // this.loading.close();
        },
        // 选择维度积分
        selectHostDimension(value,n){
            let arr = this.faceGradeList.filter(i=>i.value === value)
            this.faceGrade = arr[0].grade
            // if(n === 1){
            //     let arr = this.hostGradeList.filter(i=>i.value === value)
            //     this.hostGrade  = arr[0].grade
            // }else if(n === 2){
            //     let arr = this.entryGradeList.filter(i=>i.value === value)
            //     this.entryGarde = arr[0].grade
            // }else if(n === 3){
            //     let arr = this.faceGradeList.filter(i=>i.value === value)
            //     this.faceGrade = arr[0].grade
            // }else if(n === 4){
            //     let arr = this.faceGradeList.filter(i=>i.value === value)
            //     this.prizeGrade = arr[0].grade
            // }else if(n === 5){
            //     let arr = this.refereeGradeList.filter(i=>i.value === value)
            //     this.refereeGrade =  arr[0].grade
            // }
        },
         // 选择纬度积分 荣誉分设置 SetLevelGrade
         submitGrade(){
            let params = {
                opcode: this.$code.SetLevelGrade,
                i_serial_mark: this.publishId,
                i_integral: this.totalGrade,
                d_host_dimension: this.ruleForm.hostDimension,
                d_entry_dimension: this.ruleForm.entryDimension,
                d_face_dimension: this.ruleForm.faceDimension,
                d_prize_dimension: this.ruleForm.prizeDimension,
                d_referee_dimension: this.ruleForm.refereeDimension
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    // console.log(res)
                }
            }).catch(err=>err)
        },
        handleFee(value){
            if(value){
                this.ruleForm.eventFee =  this.$help.numberToPrice(value);
            }else{
                this.ruleForm.eventFee = ''
            } 
        },
        handlePhone(value){
            const pattern = /^[0-9]\d*$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.ruleForm.eventContact = value
            } else {
                // 输入值不为正整数，则从中提取出数字并拼接为字符串
                const num = value.match(/\d+/g)
                this.ruleForm.eventContact = num ? num.join('') : ''
            }
        },
        // 获取裁判等级
        getRefereevalue(){
            let value = localStorage.getItem('roles')
            if(value === '裁判'){
                let roleLevel= localStorage.getItem('roleLevel')      
                let refereeLevel = Number(roleLevel)
                this.ruleForm.refereeDimension = refereeLevel
                let refereeArr =  this.gradeArr.filter(i=>i.value === refereeLevel)
                this.refereeGrade = refereeArr && refereeArr[0].grade              
            }else{
               this.ruleForm.refereeDimension = 1
               this.ruleForm.refereeGrade = 20
            }      
        },
        // 裁判等级 分数最大值
        getRefereeLevel(value){
            console.log('裁判最大值',value,this.ruleForm.refereeDimension)
            if(value >= this.ruleForm.refereeDimension){
                let refereeLevel = Number(value)
                this.ruleForm.refereeDimension = refereeLevel
                let refereeArr =  this.gradeArr.filter(i=>i.value === refereeLevel)
                this.refereeGrade = refereeArr && refereeArr[0].grade    
                setTimeout(()=>{
                    this.submitGrade()
                },1000)
            }else{
                this.ruleForm.refereeDimension = 1
                this.refereeGrade = 20
                setTimeout(()=>{
                    this.submitGrade()
                },1000)
            }
        },
        // 主办方 承办 协办 分数最大值
        getMaxLevel(value){
            console.log('主办方 承办 协办 分数最大值',value,this.ruleForm.hostDimension)
            if(value >= this.ruleForm.hostDimension){
                let hostLevel = Number(value)
                this.ruleForm.hostDimension = hostLevel
                let hostArr =  this.gradeArr.filter(i=>i.value === hostLevel)
                this.hostGrade = hostArr && hostArr[0].grade    
                setTimeout(()=>{
                    this.submitGrade()
                },1000)
            }else{
                this.ruleForm.hostDimension = 1
                this.hostGrade = 20
                setTimeout(()=>{
                    this.submitGrade()
                },1000)
            }
        },
        async querySearchSponsor(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString, 'a') : []  
            cb(result)
        },
        async querySearchGuidance(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString, 'b') : []  
            cb(result)
        },
        // 模糊搜索查询
        getUserInfoSearch(val,flag){
            return new Promise((resolve,reject)=>{
                if(val.length > 1){
                    let params = {
                        opcode: this.$code.UserInfoSearch,
                        v_name: val,
                        v_caption: '',
                        v_phone: '',
                    }
                    // 查询信息
                    this.$api._requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            let result = res.Data.DataTable
                            if(result.length === 0){
                                if(flag === 'b'){
                                    this.ruleForm.guidanceNo = ''
                                } 
                            }else{
                                let arr  = result.map(item=>{
                                    return{
                                        value:item['姓名'] +''+ item['手机号'],
                                        userId: item['会员账号'],
                                        username: item['姓名'],
                                        phone: item['手机号'],   
                                        role: item['角色']                                     
                                    }
                                })                            
                                let filterArr = arr.filter(i=>i.role === '掼蛋协会'||i.role === '掼蛋俱乐部')
                                resolve(filterArr)                         
                            }
                    }
                    }).catch(err => { reject(err)})
                }else{
                    if(flag === 'b'){
                        this.ruleForm.guidanceNo = ''
                    }     
                }
            })         
        },    
        handleSelectGuidance(row){
            this.ruleForm.guidanceName  = row.username
            this.ruleForm.guidanceNo = row.userId
        },  
        handleSelectSponsor(row){
            this.ruleForm.sponsor  = row.username
        },
        handleChangeSponsor(value){
            if(value === ''){
                this.ruleForm.sponsorNo = ''
            }
        },
        handleChangeGuidance(value){
            if(value === ''){
                this.ruleForm.guidanceNo = ''
            }
        },
        selectArea(value){
            // console.log(value,this.ruleForm)
            if(value.length > 0){
                let arr =  value
                this.ruleForm.province = arr[0]
                this.ruleForm.city = arr[1]
            }        
        }        
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.image {
  position: relative;

  .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }

  &:hover .mask {
    opacity: 1;
  }
}
.container {
    background-color: #fff;
}

.detail-wrap {
    width: 1000px;
    // padding: 30px 60px;
    font-size: 16px;
    line-height: 28px;
}
.pub-title{
    text-align: center;
    font-size: 20px;
}
.sub-title{
    padding: 4px 15px;
    font-size: 18px;
    color: #fff;
    background-color: #e62e02;
    border-radius: 5px;
}
.sub-name{
    padding: 10px;
}
.mg-t-20{
    margin-top: 30px;
}
.pub-submit{
    margin-top: 16px;
    width: 30%;
    font-size: 16px;
}
.text-tips{
    margin-left: 200px;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/UpdatePreview.vue